module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-10.c7eebd6b.jpg";